<router-outlet></router-outlet>
<app-pwa-install-floater></app-pwa-install-floater>
